import React from 'react';
import PropTypes from 'prop-types';
import { RosterVersion, Settings } from 'components/Timeline';
import { AddTags } from 'components/Page';
import RosterTimeline from './RosterTimeline';

const Roster = ({ match, ...rest }) => {
  const { params } = match;
  return (
    <RosterVersion.Provider value={{ rosterVersion: params.id }}>
      <RosterTimeline match={match} {...rest} />
    </RosterVersion.Provider>
  );
};

Roster.propTypes = {
  match: PropTypes.object.isRequired
};

export default AddTags(Settings(Roster));
